import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";
import translationEN from '../helper/localizations/en.json';
import translationAR from '../helper/localizations/ar.json';

// Initialize with saved language or default to English
const savedLanguage = localStorage.getItem('language') || 'en';

const resources = {
  en: { translation: translationEN },
  ar: { translation: translationAR }
};

i18n
  .use(reactI18nextModule)
  .init({
    resources,
    lng: savedLanguage, // Use saved language
    fallbackLng: "en",
    keySeparator: '.',
    interpolation: {
      escapeValue: false
    },
    react: {
      wait: true,
      bindI18n: 'languageChanged',
      nsMode: 'default'
    }
  });

// Set initial direction
document.documentElement.dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = savedLanguage;

export default i18n;